import React from 'react'
import createIcon from '@/lib/create-icon'

export const MarkerSVGIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 2L14 5.33333L5.33333 14H2V10.6667L10.6667 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
